import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/scroll";

const ANCHOR_LINKS = [
    { label: "Services", id: "services" },
    { label: "How It Works", id: "how-it-works" },
    { label: "FAQ", id: "faq" },
    { label: "Contact", id: "audit" },
];

export const Footer = () => (
    <footer className="border-t border-white/10 bg-ink-900">
        <div className="shell py-14 md:py-16">
            <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
                <div>
                    <Logo
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToId("top");
                        }}
                    />
                    <p className="mt-4 text-sm text-zinc-500">
                        Performance Marketing for U.S. Law Firms
                    </p>
                </div>
                <nav aria-label="Footer" className="flex flex-wrap gap-x-8 gap-y-3 md:justify-end">
                    {ANCHOR_LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={`#${l.id}`}
                            data-testid={`footer-link-${l.label.toLowerCase()}`}
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToId(l.id);
                            }}
                            className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                    <Link
                        to="/privacy"
                        data-testid="footer-link-privacy-policy"
                        className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
                    >
                        Privacy Policy
                    </Link>
                    <Link
                        to="/terms"
                        data-testid="footer-link-terms"
                        className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
                    >
                        Terms
                    </Link>
                </nav>
            </div>
            <div className="mt-12 pt-8 border-t border-white/5">
                <p className="text-xs text-zinc-600" data-testid="footer-copyright">
                    © 2026 Scalehaus. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
